































import { computed, defineComponent, toRefs } from '@vue/composition-api';

const name = 'ttam-smart-creative-error-tip';
export default defineComponent({
  props: {
    showCardError: {
      type: Boolean,
      default: false,
    },
    showPageError: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { showCardError, showPageError } = toRefs(props);
    const createCard = () => {
      emit('create-card');
    };

    const createPage = () => {
      emit('create-page');
    };

    const isAllErrors = computed(() => showCardError.value && showPageError.value);

    return {
      name,
      createCard,
      createPage,
      isAllErrors,
    };
  },
});
